import { useEffect, useState } from "react"

/**
 * useSectionSpy — track which section id is currently in view.
 * Quiet IntersectionObserver-based scroll spy; no scroll listeners.
 *
 * @param {string[]} ids        section element ids to observe
 * @param {string}   rootMargin observer root margin (default biases toward the top band)
 * @returns {string|null}       the id of the section currently intersecting
 */
export function useSectionSpy(ids, rootMargin = "-20% 0px -70% 0px") {
  const [activeId, setActiveId] = useState(ids[0] || null)

  useEffect(() => {
    const els = ids.map((id) => document.getElementById(id)).filter(Boolean)
    if (!els.length) return

    const obs = new IntersectionObserver(
      (entries) => {
        for (const e of entries) {
          if (e.isIntersecting) {
            setActiveId(e.target.id)
            break
          }
        }
      },
      { rootMargin }
    )

    els.forEach((el) => obs.observe(el))
    return () => obs.disconnect()
    // recreate observer when ids change
  }, [ids, rootMargin])

  return activeId
}
